import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  HeadObject: {
    A_VocTyp: "",
    A_VocTypName: "",
    A_VocNo: "",
    A_PostDt: new Date(), // dd/MM/yyyy
    A_ReceiptDt: new Date(), // dd/MM/yyyy
    A_Loc: "",
    A_LocName: "",
    A_DocStat: "ENTER",
    Truck: "",
    Driver: "",
  },
};

const SliceWMSSalesReport = createSlice({
  name: "SliceWMSSalesReport",
  initialState: { value: initialState },

  reducers: {
    //including   RESET ALL
    Set_WMSSalesReport_Init: (state) => {
      state.value = initialState;
    },

    //RESET HEAD
    Set_WMSSalesReport_HeadObject_Init: (state) => {
      state.value.HeadObject = initialState.HeadObject;
    },

    Set_WMSSalesReport_HeadObject_Set: (state, action) => {
      state.value.HeadObject = action.payload;
    },
  },
});

export const {
  Set_WMSSalesReport_Init,
  Set_WMSSalesReport_HeadObject_Set,
  Set_WMSSalesReport_HeadObject_Init,
} = SliceWMSSalesReport.actions;
export default SliceWMSSalesReport.reducer;
